const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate fallbackBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const primaryValue = await evaluateSource(source.primarySource, content, parentContentPath, transientContext, nativeFunctions);
  if (primaryValue !== undefined) {
    return primaryValue;
  }
  const secondaryValue = await evaluateSource(source.secondarySource, content, parentContentPath, transientContext, nativeFunctions);
  if (secondaryValue !== undefined) {
    return secondaryValue;
  }

  // fallbackBeahavior can have an array of values that are
  // conditionals.  The first conditional that returns a defined
  // value is returned from this behavior.
  const values = source.values;
  if (Array.isArray(values)) {
    // loop over values and find one that matches.
    for (let i = 0; i < values.length; i += 1) {
      const test = values[i];
      if (test !== undefined) {
        // eslint-disable-next-line no-await-in-loop
        const testVal = await evaluateSource(test, content, parentContentPath, transientContext, nativeFunctions);
        if (testVal !== undefined) {
          // jumps us out of the function.
          return testVal;
        }
      }
    }
  }
  return undefined;
};
module.exports = {
  evaluate
};